function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n        z-index: calc(",
        " + 1);\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { css } from "@emotion/react";
import { Backdrop, CircularProgress } from "@mui/material";
var Loading = function(param) {
    var open = param.open, onClick = param.onClick, zIndex = param.zIndex;
    return /*#__PURE__*/ _jsx(Backdrop, {
        open: open,
        onClick: onClick,
        css: css(_templateObject(), zIndex),
        children: /*#__PURE__*/ _jsx(CircularProgress, {
            color: "inherit"
        })
    });
};
export default Loading;
